"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Utils = void 0;
var inversify_1 = require("inversify");
var config_1 = require("./config");
var Utils = /** @class */ (function () {
    function Utils(config) {
        this.config = config;
    }
    /**
     * 创建promise，另类用法
     */
    Utils.prototype.createPromise = function () {
        var res = function () { };
        var rej = function () { };
        var prms = new Promise(function (resolve, reject) {
            res = resolve;
            rej = reject;
        });
        return {
            prms: prms,
            res: res,
            rej: rej
        };
    };
    /**
     * 发送请求包给所有目标
     * @param playload 请求包
     */
    Utils.prototype.sendToAll = function (playload) {
        var frameSet = new Set();
        var current = window;
        while (true) {
            frameSet.add(current);
            for (var i = 0; i < 1000; i++) {
                try {
                    current.frames[i] && frameSet.add(current.frames[i]);
                }
                catch (e) {
                    break;
                }
            }
            if (current === current.parent)
                break;
            current = current.parent;
        }
        frameSet.forEach(function (frame) {
            var _a;
            frame.postMessage(playload, (_a = playload.origin) !== null && _a !== void 0 ? _a : '*');
        });
    };
    Utils = __decorate([
        inversify_1.injectable(),
        __metadata("design:paramtypes", [config_1.Config])
    ], Utils);
    return Utils;
}());
exports.Utils = Utils;
//# sourceMappingURL=utils.js.map